module.exports = "https://cdn.littlereply.com/tt/resource/icon_line_cancel.fce3036feb7b8132d09840e83dfea64d.png";